import { useDispatch } from 'react-redux';
import { notificationSlice } from 'store/slices';

export const useNotification = () => {
  const dispatch = useDispatch();

  const showSuccess = (message: string) => {
    dispatch(
      notificationSlice.actions.setNotice({
        showNotice: true,
        noticeContent: message,
        noticeBGColor: '#4caf50', // Green color for success
      })
    );
  };

  const showError = (message: string) => {
    dispatch(
      notificationSlice.actions.setNotice({
        showNotice: true,
        noticeContent: message,
        noticeBGColor: '#f44336', // Red color for error
      })
    );
  };

  const showWarning = (message: string) => {
    dispatch(
      notificationSlice.actions.setNotice({
        showNotice: true,
        noticeContent: message,
        noticeBGColor: '#ff9800', // Orange color for warning
      })
    );
  };

  const showInfo = (message: string) => {
    dispatch(
      notificationSlice.actions.setNotice({
        showNotice: true,
        noticeContent: message,
      })
    );
  };

  return {
    showSuccess,
    showError,
    showWarning,
    showInfo,
  };
};
